/* Tag filter for the "Collection with tag filters" section.
   Server renders every product once; this only shows and hides them.
   Selecting several chips inside one group is OR; across groups it is AND. */
(function () {
  var SEL = '[data-tagfilter]';

  function init(root) {
    if (!root || root.__tfInit) return; // section:load fires on every editor edit
    root.__tfInit = true;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-tf-item]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-tf-chip]'));
    var empty = root.querySelector('[data-tf-empty]');
    var clear = root.querySelector('[data-tf-clear]');
    var live  = root.querySelector('[data-tf-live]');
    // Page size comes from the section's "Products per page" setting
    // (data-tf-perpage). 0 (the default) shows the whole filtered set with no
    // pager, unchanged from before this setting existed. window.LDB_TF_PERPAGE
    // stays as a manual override hook for a page that has no section markup.
    var perPage = parseInt(root.getAttribute('data-tf-perpage'), 10) || 0;
    if (!perPage && typeof window.LDB_TF_PERPAGE === 'number') perPage = window.LDB_TF_PERPAGE;

    // The pager markup can come from the section, but is created here when absent
    // so pagination works without a theme edit.
    var pager = root.querySelector('[data-tf-pager]');
    if (!pager && perPage > 0) {
      var gridForPager = root.querySelector('[data-tf-grid]');
      if (gridForPager && gridForPager.parentNode) {
        pager = document.createElement('nav');
        pager.className = 'tagfilter-pager';
        pager.setAttribute('data-tf-pager', '');
        pager.setAttribute('aria-label', 'Pagination');
        pager.hidden = true;
        gridForPager.parentNode.insertBefore(pager, gridForPager.nextSibling);
      }
    }
    var page = 1;
    var order = items.slice(); // current visual order (updated by sort)

    // selected[groupIndex] = Set of values
    var selected = {};
    var seenGroups = {};

    function valuesOf(item, group) {
      var raw = item.getAttribute('data-g' + group) || '';
      return raw.length ? raw.split(' ') : [];
    }

    function matches(item) {
      for (var g in selected) {
        if (!selected[g] || !selected[g].length) continue;
        var have = valuesOf(item, g);
        var hit = false;
        for (var i = 0; i < selected[g].length; i++) {
          if (have.indexOf(selected[g][i]) !== -1) { hit = true; break; }
        }
        if (!hit) return false; // AND across groups
      }
      return true;
    }

    // ---- pagination + render -----------------------------------------
    // Every card stays in the DOM so the filter can see all of them; render()
    // shows only the current page's slice of the filtered, sorted set. With
    // perPage = 0 the whole filtered set shows and no pager is drawn, which is
    // how the small brand/sealed collections behave.
    function pageWindow(cur, pages) {
      var out = [];
      for (var i = 1; i <= pages; i++) {
        if (i === 1 || i === pages || (i >= cur - 1 && i <= cur + 1)) {
          out.push(i);
        } else if (out[out.length - 1] !== '…') {
          out.push('…');
        }
      }
      return out;
    }

    function renderPager(pages) {
      if (!pager) return;
      if (perPage <= 0 || pages <= 1) { pager.hidden = true; pager.innerHTML = ''; return; }
      pager.hidden = false;
      var html = '';
      html += '<button type="button" class="tagfilter-page tagfilter-page-arrow" data-tf-page="' + (page - 1) + '"' + (page === 1 ? ' disabled' : '') + ' aria-label="Previous page">‹</button>';
      pageWindow(page, pages).forEach(function (p) {
        if (p === '…') {
          html += '<span class="tagfilter-page-gap" aria-hidden="true">…</span>';
        } else {
          html += '<button type="button" class="tagfilter-page' + (p === page ? ' is-active' : '') + '" data-tf-page="' + p + '"' + (p === page ? ' aria-current="page"' : '') + '>' + p + '</button>';
        }
      });
      html += '<button type="button" class="tagfilter-page tagfilter-page-arrow" data-tf-page="' + (page + 1) + '"' + (page === pages ? ' disabled' : '') + ' aria-label="Next page">›</button>';
      pager.innerHTML = html;
    }

    function render() {
      var matched = order.filter(matches);
      var total = matched.length;
      var pages = perPage > 0 ? Math.max(1, Math.ceil(total / perPage)) : 1;
      if (page > pages) page = pages;
      if (page < 1) page = 1;
      var startI = perPage > 0 ? (page - 1) * perPage : 0;
      var endI = perPage > 0 ? startI + perPage : total;
      items.forEach(function (it) { it.hidden = true; });
      for (var i = startI; i < endI && i < total; i++) matched[i].hidden = false;
      if (empty) empty.hidden = total !== 0;
      if (live) live.textContent = total + (total === 1 ? ' product' : ' products');
      var any = Object.keys(selected).some(function (g) { return selected[g] && selected[g].length; });
      if (clear) clear.hidden = !any;
      renderPager(pages);
    }

    function apply() {
      page = 1; // a filter change always returns to the first page
      render();
    }

    if (pager) {
      pager.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tf-page]');
        if (!b || b.disabled) return;
        var p = parseInt(b.getAttribute('data-tf-page'), 10);
        if (!p || p === page) return;
        page = p;
        render();
        var g = root.querySelector('[data-tf-grid]');
        if (g) {
          var y = g.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
        }
      });
    }

    function setChip(chip, on) {
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      chip.classList.toggle('is-active', on);
    }

    function syncGroupChips(group) {
      var mine = chips.filter(function (c) { return c.getAttribute('data-group') === String(group); });
      mine.forEach(function (c) {
        var v = c.getAttribute('data-value');
        if (v === '') setChip(c, !(selected[group] && selected[group].length)); // the "All" chip
        else setChip(c, !!(selected[group] && selected[group].indexOf(v) !== -1));
      });
      syncSummary(group, mine);
    }

    // The count badge lives inside the option button, so read the name without it.
    function labelOf(btn) {
      var copy = btn.cloneNode(true);
      var badge = copy.querySelector('.tagfilter-count');
      if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
      return copy.textContent.replace(/\s+/g, ' ').trim();
    }

    // The dropdown toggle has to say what is picked without opening it:
    // one name when one thing is picked, a count past that, the "All" word when nothing is.
    function syncSummary(group, mine) {
      if (!mine.length) return;
      var dd = mine[0].closest('[data-tf-dd]');
      if (!dd) return;
      var out = dd.querySelector('[data-tf-dd-value]');
      if (!out) return;
      var picked = (selected[group] || []).slice();
      if (!picked.length) {
        out.textContent = out.getAttribute('data-tf-dd-empty') || 'All';
        dd.classList.remove('has-selection');
        return;
      }
      dd.classList.add('has-selection');
      if (picked.length === 1) {
        var hit = mine.filter(function (c) { return c.getAttribute('data-value') === picked[0]; })[0];
        out.textContent = hit ? labelOf(hit) : picked[0];
      } else {
        out.textContent = picked.length + ' selected';
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var group = chip.getAttribute('data-group');
        var value = chip.getAttribute('data-value');
        var multi = chip.getAttribute('data-multi') === 'true';
        if (!selected[group]) selected[group] = [];

        if (value === '') {
          selected[group] = [];                       // "All" clears the group
        } else if (!multi) {
          selected[group] = selected[group].indexOf(value) !== -1 ? [] : [value];
        } else {
          var at = selected[group].indexOf(value);
          if (at === -1) selected[group].push(value);
          else selected[group].splice(at, 1);
        }
        syncGroupChips(group);
        apply();
      });
    });

    if (clear) {
      clear.addEventListener('click', function () {
        selected = {};
        chips.forEach(function (c) {
          var g = c.getAttribute('data-group');
          syncGroupChips(g);
        });
        apply();
      });
    }

    // ---- sorting ------------------------------------------------------
    // Every card is already in the DOM, so sorting is a reorder, not a fetch.
    var grid = root.querySelector('[data-tf-grid]');
    var sortBtns = Array.prototype.slice.call(root.querySelectorAll('[data-tf-sort]'));
    var sortOut = root.querySelector('[data-tf-sort-value]');

    function num(el, attr) {
      var n = parseFloat(el.getAttribute(attr));
      return isNaN(n) ? 0 : n;
    }

    var COMPARE = {
      'featured':   function (a, b) { return num(a, 'data-tf-i') - num(b, 'data-tf-i'); },
      'title-asc':  function (a, b) { return (a.getAttribute('data-tf-title') || '').localeCompare(b.getAttribute('data-tf-title') || ''); },
      'title-desc': function (a, b) { return (b.getAttribute('data-tf-title') || '').localeCompare(a.getAttribute('data-tf-title') || ''); },
      'price-asc':  function (a, b) { return num(a, 'data-tf-price') - num(b, 'data-tf-price'); },
      'price-desc': function (a, b) { return num(b, 'data-tf-price') - num(a, 'data-tf-price'); },
      'date-desc':  function (a, b) { return num(b, 'data-tf-date') - num(a, 'data-tf-date'); },
      'date-asc':   function (a, b) { return num(a, 'data-tf-date') - num(b, 'data-tf-date'); }
    };

    function applySort(key) {
      var cmp = COMPARE[key] || COMPARE.featured;
      if (!grid) return;
      var sorted = items.slice().sort(function (a, b) {
        var r = cmp(a, b);
        // Ties keep the collection's own order, so a sort is never arbitrary.
        return r !== 0 ? r : num(a, 'data-tf-i') - num(b, 'data-tf-i');
      });
      var frag = document.createDocumentFragment();
      sorted.forEach(function (el) { frag.appendChild(el); });
      grid.appendChild(frag);
      order = sorted; // keep pagination in the same order as the DOM
      page = 1;
      render();
    }

    function setSort(key, btn) {
      sortBtns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (sortOut && btn) sortOut.textContent = labelOf(btn);
      applySort(key);
    }

    sortBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSort(btn.getAttribute('data-sort'), btn);
        closeAll();
      });
    });

    var initialSort = sortBtns.filter(function (b) { return b.classList.contains('is-active'); })[0] || sortBtns[0];
    if (initialSort) setSort(initialSort.getAttribute('data-sort'), initialSort);

    // ---- dropdowns ----------------------------------------------------
    var dds = Array.prototype.slice.call(root.querySelectorAll('[data-tf-dd]'));

    function closeAll(except) {
      dds.forEach(function (dd) {
        if (dd === except) return;
        var t = dd.querySelector('[data-tf-dd-toggle]');
        var pnl = dd.querySelector('[data-tf-dd-panel]');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (pnl) pnl.hidden = true;
        dd.classList.remove('is-open');
      });
    }

    dds.forEach(function (dd) {
      var toggle = dd.querySelector('[data-tf-dd-toggle]');
      var panel = dd.querySelector('[data-tf-dd-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = toggle.getAttribute('aria-expanded') === 'true';
        closeAll(dd);
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        dd.classList.toggle('is-open', !open);
      });

      panel.addEventListener('click', function (e) { e.stopPropagation(); });

      dd.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          closeAll();
          toggle.focus();
        }
      });
    });

    if (dds.length) {
      document.addEventListener('click', function () { closeAll(); });
      // A tab out of the last option should close the menu behind you.
      root.addEventListener('focusout', function (e) {
        dds.forEach(function (dd) {
          if (!dd.contains(e.relatedTarget)) {
            var t = dd.querySelector('[data-tf-dd-toggle]');
            var pnl = dd.querySelector('[data-tf-dd-panel]');
            if (t) t.setAttribute('aria-expanded', 'false');
            if (pnl) pnl.hidden = true;
            dd.classList.remove('is-open');
          }
        });
      });
    }

    apply();
    chips.forEach(function (c) {
      var g = c.getAttribute('data-group');
      if (!seenGroups[g]) { seenGroups[g] = true; syncGroupChips(g); }
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(SEL);
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
